/*
const myShape = new TeardropShape({
  x: 50,
  y: 50,
  stroke: engraveColor,
  strokeWidth: 5,
  width: 200,
  height: 300,
});
console.log("myShape", myShape);
layer.add(myShape);
selectNode(myShape);
layer.draw();
*/
class TeardropShape extends Konva.Path {
  constructor(config) {
    super(config);
    this.className = 'TeardropShape';

    this.attrs.type = "teardropshape";

    //this.setData( generateTeardropSvgTextPath(400, 400, this.attrs.radius) );

    if (this.attrs.width == undefined) {
      this.setWidth(200);
    }

    if (this.attrs.height == undefined) {
      this.setHeight(300);
    }

    this.updatePath();
    
    this.setDraggable(true);
  }

  _width() {
    Konva.TextPath.prototype.width.call(this);
  }

  _height() {
    Konva.TextPath.prototype.height.call(this);
  }
}

TeardropShape.prototype.getWidth = function () {
  return this.attrs.width;
};

TeardropShape.prototype.setWidth = function (width) {
  this.attrs.width = parseInt(width);
  this.updatePath();
};

TeardropShape.prototype.getHeight = function () {
  return this.attrs.height;
};

TeardropShape.prototype.setHeight = function (height) {
  this.attrs.height = height;
  this.updatePath();
};

TeardropShape.prototype.updatePath = function () {
  this.setData(this.generateSvgPath(this.getWidth(), this.getHeight()));
};

TeardropShape.prototype.generateSvgPath = function(size) {
  const k = size / 210;
  const path = `M0,${200 * k} C0,${150 * k} ${50 * k},${100 * k} ${100 * k},${100 * k} C${150 * k},${100 * k} ${200 * k},${150 * k} ${200 * k},${200 * k} C${200 * k},${250 * k} ${150 * k},${300 * k} ${100 * k},${350 * k} C${50 * k},${300 * k} 0,${250 * k} 0,${200 * k} Z`;
  return path;
}

